export default __webpack_public_path__ + "static/media/profile_av.2a63d0b0.svg";